<template>
    <div class="orderDetail">
        <el-row>
            <el-col :span="24" class="no-return-title">包裹信息</el-col>
        </el-row>
        <el-row>
            <el-col :span="5" class="outer-border left">
                <el-row style="margin-bottom:20px">
                    <el-col :span="5">
                        <img src="../../assets/img/23.png" alt style="margin-bottom:20px" />
                    </el-col>
                    <el-col :span="24" class="words">订单号码：111111225666666</el-col>
                    <el-col :span="24" class="words">运单单号：2233156565466699855</el-col>
                    <el-col :span="24" class="words">客服电话：400-628-1365</el-col>
                    <el-col :span="24" class="words">物流公司：顺丰快运</el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="dotted" style="margin-bottom:20px">
                        <span class="title-c">收货地址：</span>
                        <span class="words">北京市市辖区海淀区中关村大街111号美林大厦11层1111（洞洞拐收）18910891189</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="dotted" style="margin-bottom:20px">
                        <span class="title-c">收货地址：</span>
                        <span class="words">北京市市辖区海淀区中关村大街111号美林大厦11层1111（洞洞拐收）18910891189</span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="18" class="right">
                <div class="time-line">
                    <div v-for="(item,index) in testList" :key="index" class="time-line-div">
                        <p>{{item.time}}</p>
                        <p ref="circular"></p>
                        <p>{{item.text}}</p>
                    </div>
                    <div class="img-dotted" ref="dotted"></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "orderDetail",
    data() {
        return {
            testList: [
                {
                    key: "1",
                    time: "2019-12-12  周四  18:02:00",
                    text: "第一步第一步第一步第一步第一步"
                },
                {
                    key: "2",
                    time: "2019-12-12  周四  18:02:00",
                    text: "第二步第二步第二步第二步第二步"
                },
                {
                    key: "3",
                    time: "2019-12-12  周四  18:02:00",
                    text: "第三步第三步第三步第三步第三步"
                },
                {
                    key: "4",
                    time: "2019-12-12  周四  18:02:00",
                    text: "第四步第四步第四步第四步第四步"
                },
                {
                    key: "5",
                    time: "2019-12-12  周四  18:02:00",
                    text: "第五步第五步第五步第五步第五步"
                }
            ],
        };
    },
    mounted() {
        this.$refs.dotted.style.left =
            this.$refs.circular[0].offsetLeft - 12 + "px";
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-return-title {
    font-size: 22px;
    color: #333333;
    padding: 39px 0px 19px;
}
.left {
    padding: 20px;
    min-height: 583px;
}
.words {
    color: #999999;
    line-height: 24px;
}
.title-c {
    color: #666666;
    font-weight: bold;
}
.dotted {
    border-top: 1px dotted #dddddd;
    padding-top: 20px;
}
.right {
    margin-left: 20px;
    min-height: 583px;
    background-color: #f9f9f9;
    border: solid 1px #dddddd;
    padding: 40px 20px;
}

.time-line {
    position: relative;
    /* width: 300px; */
    /* margin:0 auto; */
}
.time-line-div {
    position: relative;
    min-height: 85px;
}
.time-line-div > p:nth-child(1) {
    position: absolute;
    left: 0;
    width: 200px;
    font-size:12px;
    color: #666666;
    padding: 10px;
}
.time-line-div > p:nth-child(2) {
    position: absolute;
    left: 200px;
    width: 15px;
    height: 15px;
    top: 10px;
    background: #f64420;
    /* background: #bbbbbb; */
    border-radius: 50%;
    z-index: 10;
}
.time-line-div > p:nth-child(3) {
    position: absolute;
    left: 230px;
    padding: 10px;
    font-size: 14px;
    color: #666666;
    border-radius: 10px;
}
.img-dotted {
    position: absolute;
    width: 20px;
    height: 100%;
    top: 0;
    z-index: 1;
    border-right: 1px solid #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/noTitleNoReturn/orderDetail.vue